import { useSetAtom } from "jotai";

import { menuAtom } from "./atoms";
import { MenuTriggerEvent, OpenMenuAction } from "./types";

export const useMenu = () => {
  const setMenu = useSetAtom(menuAtom);

  const openMenu = ({
    event,
    menu,
    isRelativeToElement = false,
  }: {
    event: MenuTriggerEvent;
    menu: OpenMenuAction;
    isRelativeToElement?: boolean;
  }) => {
    event.preventDefault();
    event.stopPropagation();
    setMenu({ ...menu, isRelativeToElement, event });
  };

  return { openMenu };
};
